import { useTranslation } from 'react-i18next'
import { makeStyles, useTheme } from '@mui/styles'
import { Button, TextField, Typography } from '@mui/material'

import { Card, Form } from 'ui'
import { Controller, useForm } from 'react-hook-form'

import { reqKy } from 'stores/api'
import { useGlobalSnackbarStore } from 'stores/globalSnackbar'
import { api } from 'utils/constants'

const useStyles = makeStyles((theme) => ({
    root: {
        color: theme.palette.text.primary,
    },

    instructions: {
        marginTop: '1vh',
        textAlign: 'center',
    },

    textField: {
        margin: '5vh 0',
        width: '250px',
    },
}))

export const AskResetPassword = ({ closeDialog }) => {
    const theme = useTheme()
    const classes = useStyles(theme)

    const { t } = useTranslation()
    const { showGlobalSnackbar } = useGlobalSnackbarStore()

    const { control, handleSubmit } = useForm({
        defaultValues: {
            email: '',
        },
    })

    const resetPassword = async (data) => {
        const requestResetPassword = await reqKy
            .post(api.auth.ASK_RESET_PASSWORD, {
                json: {
                    email: data.email,
                },
            })
            .json()
            .catch(() => {
                /* Empty */
            })

        if (!requestResetPassword) {
            showGlobalSnackbar('error', t('errorTryLater'))

            return
        }

        showGlobalSnackbar('success', t('sent'))
        closeDialog()
    }

    return (
        <Card className={classes.root}>
            {/* Title */}
            <Typography variant='h1'>{t('resetPassword')}</Typography>

            {/* Instructions */}
            <div className={classes.instructions}>
                {t('resetPasswordInstruction')}
            </div>

            <Form onSubmit={handleSubmit(resetPassword)}>
                {/* Email field */}
                <Controller
                    name='email'
                    control={control}
                    render={({ field }) => (
                        <TextField
                            className={classes.textField}
                            label={t('email')}
                            type='text'
                            {...field}
                            required
                        />
                    )}
                />

                {/* Send button */}
                <Button
                    variant='contained'
                    size='large'
                    type='submit'
                    fullWidth
                >
                    {t('send')}
                </Button>
            </Form>
        </Card>
    )
}
